import { useStore } from 'vuex'
import ContentCarousel from '../ContentCarousel/ContentCarousel'
import CaseCard from 'components/CaseCard/CaseCard'

export default {
    name: 'CaseCarousel',
    components: {
        ContentCarousel,
        CaseCard
    },
    props: {
        contentJson: {
            type: Object,
            required: true
        },
        link: {
            type: Object,
            required: false
        },
        type: {
            type: String,
            required: true
        },
        carouselId: {
            type: String,
            required: false
        }
    },
    setup() {
        const store = useStore()
        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'caseCarousel',
                labelKey
            })

        return {
            ContentCarousel,
            CaseCard,
            getLabel
        }
    }
}
